export const ProjectConfigOverride = {
  api_url: "https://api.connect-3s.com",
};